import * as types from 'actions/types';
const initialState = {};
const sharedBills = (state = initialState, action) => {
    switch (action.type) {
        case types.CACHE_SHARED_BILL_INFO: {
            const { payload: { id, users }, } = action;
            const sorted = [...users].sort((a, b) => {
                if (a.status === 'COMPLETED' && b.status === 'COMPLETED') {
                    return b.amount - a.amount;
                }
                if (a.status === 'COMPLETED') {
                    return -1;
                }
                if (b.status === 'COMPLETED') {
                    return 1;
                }
                return b.amount - a.amount;
            });
            return { ...state, [id]: sorted };
        }
        case types.CLEAR_SHARED_BILL_INFO_CACHE: {
            const { payload: { id }, } = action;
            const updatedCache = { ...state };
            delete updatedCache[id];
            return updatedCache;
        }
        case types.LOGGED_OUT: {
            return initialState;
        }
        default: {
            return state;
        }
    }
};
export default sharedBills;
